import { types } from "react-bricks/frontend";

// Hero components
import HeroText from "./heros/HeroText";
import HeroLandingYuniverse from "./heros/HeroYuniverse";

// Section components
import IntroductionBlock from "./sections/IntroductionBlock";
import ImageCallout from "./sections/ImageCallout";
import StatsBar from "./sections/StatsBar";
import StatsBarItem from "./sections/StatsBarItem";
import { Accordion } from "./sections/Accordion";
import { AccordionItem } from "./sections/AccordionItem";
import { TextWithImage } from "./zigzag/TextWithImage";
import { TextWithList } from "./zigzag/TextWithList";
import { TextWithChecklist } from "./zigzag/TextWithChecklist";
import { TextWithForm } from "./zigzag/TextWithForm";
import ChecklistItem from "./zigzag/ChecklistItem";
import { TextWithHeadingBlock } from "./zigzag/TextWithHeadingBlock";
import { Callback } from "./sections/Callback";
import { InfoCard } from "./cards/InfoCard";
import { InfoCardSection } from "./cards/InfoCardSection";
import TrustpilotSection from "./sections/TrustpilotSection";
import QuoteCarousel from "./sections/QuoteCarousel";
import { TestimonialItem } from "./sections/TestimonialItem";
import ButtonStrip from "./sections/ButtonStrip";
import KeyResources from "./sections/KeyResources";
import HubspotFormField from "./forms/HubspotFormField";
import HeroForm from "./heros/HeroForm";
import HeroLeftText from "./heros/HeroLeftText";
import HeroLandingImage from "./heros/HeroLandingImage";
import ListItem from "./zigzag/ListItem";
import GlobalRewardsMap from "./sections/GlobalRewardsMap";
import RewardsList from "./sections/RewardsList";
import { VideoStrip } from "./sections/VideoStrip";
import { Spacer } from "./sections/Spacer";
import JapanPage from "./jp/japan-page";
import ScrollToPoint from "./common/ScrollToPoint";
import TextWithModal from "./common/TextWithModal";
import EventsBar from "./landing-page-bricks/EventsBar";
import EventsBarItem from "./landing-page-bricks/EventsBarItem";
import Logo from "./common/Logo";
import ImageSection from "./landing-page-bricks/ImageSection";
import BackgroundSection from "./landing-page-bricks/BackgroundSection";
import Map from "./landing-page-bricks/Map";
import LandingPageFooter from "./landing-page-bricks/LandingPageFooter";
import HubspotAutoForm from "./forms/HubspotAutoForm";
import Timeline from "./landing-page-bricks/Timeline";
import TimelineItem from "./landing-page-bricks/TimelineItem";
import TrustpilotSectionSmall from "./sections/TrustpilotSectionSmall";
import { LogoWall } from "./landing-page-bricks/LogoWall";
import LogoWallImage from "./landing-page-bricks/LogoWallImage";
import { PressKitSection } from "./sections/PressKitSection";
import { LogoSection } from "./sections/LogoSection";

const bricks: types.Theme[] = [
  {
    themeName: "YuLife - Website",
    categories: [
      {
        categoryName: "Top Landing Section",
        bricks: [HeroLandingYuniverse, HeroForm, HeroLandingImage],
      },
      {
        categoryName: "Form capture",
        bricks: [TextWithForm],
      },
      {
        categoryName: "Website bricks",
        bricks: [
          Accordion,
          AccordionItem,
          ButtonStrip,
          Callback,
          HeroText,
          ImageCallout,
          InfoCard,
          InfoCardSection,
          IntroductionBlock,
          KeyResources,
          QuoteCarousel,
          StatsBar,
          StatsBarItem,
          TestimonialItem,
          TextWithImage,
          TextWithList,
          TextWithChecklist,
          TrustpilotSection,
          TrustpilotSectionSmall,
          VideoStrip,
          Spacer,
          GlobalRewardsMap,
          RewardsList,
          JapanPage,
          ScrollToPoint,
          PressKitSection,
        ],
      },
      {
        categoryName: "Landing Page Bricks",
        bricks: [EventsBar, LandingPageFooter, BackgroundSection, Timeline, LogoWall],
      },
      {
        categoryName: "Hidden",
        bricks: [
          ChecklistItem,
          HubspotFormField,
          TextWithHeadingBlock,
          HeroLeftText,
          ListItem,
          TextWithModal,
          EventsBarItem,
          Logo,
          ImageSection,
          Map,
          HubspotAutoForm,
          TimelineItem,
          LogoWallImage,
          LogoSection,
        ],
      },
    ],
  },
];

export default bricks;
